import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Prescription } from '@models/prescription';
import { Patient } from '@models/patient';
import { PrescriptionForm } from '@classes/prescription-form';
import { RX_STATUS_OPTIONS } from '../../../../constants/rx-status';

@Component({
  selector: 'app-prescription-details',
  templateUrl: './prescription-details.component.html',
  styleUrls: ['./prescription-details.component.css', '../order.component.css'],
})
export class PrescriptionDetailsComponent implements OnInit {
  @Input() orderForm: FormGroup;
  @Input() patient: Patient;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  formGroup: FormGroup;
  rxStatusOptions = RX_STATUS_OPTIONS;

  ngOnInit(): void {
    if (!this.formGroup) {
      this.formGroup = PrescriptionForm.initPrescriptionFormGroup(new Prescription());
    }
  }

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }

  onPost(): void {
    this.onSave('POST');
  }
}
